// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "calendar_sync_outbox".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "calendar_sync_outbox" table (1:1 with a DB row, on the wire). */
export const calendarSyncOutboxAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    entityId: z.string(),
    action: z.enum(['upsert', 'delete']),
    calendarAccountId: z.string().nullable(),
    externalEventId: z.string().nullable(),
    calendarIdOverride: z.string().nullable(),
    externalEtag: z.string().nullable(),
    notifyAttendees: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=calendarSyncOutbox.js.map